<template>
  <toggleable-menu ref="menu" min-width="400px" :nudge-right="260" :nudge-bottom="10" origin="top left" dark-btn @close:all="onClose">
    <template slot="data" slot-scope="{ data }">

      <v-toolbar dense card dark class="title gradient">
        <span class="ml-40">#{{ data.id }}</span>

        <alert-chip v-if="data.pendente !== 0" color="warning" class="ml-4">
          {{ $t('prenotazioni.label.da_confermare') }}
        </alert-chip>

        <v-btn fab small absolute left bottom color="white" @click="onEditClick(data)" light>
          <v-icon>{{ $store.getters.isAbbonamentoExpired ? 'info_outline' : 'edit' }}</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="body-2">
        <v-flex xs12 class="mt-2">
          <icon-label icon="access_time" class="body-2" center
                      :hint="$t('label.data')">
            {{ $d($utils.date.toJs(data.data_controllo), 'long') }}, {{ data.ora_controllo }}
          </icon-label>
        </v-flex>

        <v-flex xs12 class="mt-2">
          <icon-label icon="location_on" class="body-2" center
                      :hint="$t('label.indirizzo')">
            {{ $utils.formatAddress(data.nome_nazione, data.nome_regione, data.sigla_provincia, data.nome_comune, data.cap, data.frazione, data.via, data.numero_civico) }}
          </icon-label>
        </v-flex>

        <v-flex xs12 class="mt-2">
          <icon-label icon="person_outline" class="body-2" center
                      :hint="$t('label.cliente')">
            {{ $store.getters.getAgricoltoreById(data.id_agricoltore).ragione_sociale }}
          </icon-label>
        </v-flex>

        <v-flex xs12 class="mt-2" v-if="data.id_tecnico">
          <icon-label icon="person" class="body-2" center
                      :hint="$t('prenotazioni.label.tecnico')">
            {{ ((t) => `${t.nome_cognome}, ${t.telefono}`)($store.getters.getTecnicoById(data.id_tecnico)) }}
          </icon-label>
        </v-flex>

        <v-flex xs12 class="mt-2" v-if="data.targa_unita_mobile">
          <icon-label icon="local_shipping" class="body-2" center
                      :hint="$t('label.unita_mobile')">
            {{ data.targa_unita_mobile }}
          </icon-label>
        </v-flex>
      </v-card-text>

    </template>

  </toggleable-menu>
</template>

<script>
import ToggleableMenu from '@/components/base/ToggleableMenu'

export default {
    name: 'PrenotazioneInfoMenu',
    components: { ToggleableMenu },
    methods: {
        showInfo (activatorId, prenotazione) {
            this.$refs.menu.show(activatorId, prenotazione)
        },
        close () {
            this.$refs.menu.close()
        },
        onEditClick (data) {
            this.$refs.menu.close()
            this.$emit('click:edit', data)
        },
        onClose () {
            this.$emit('close')
        }
    }
}
</script>
